import url from "../../config/url";
import axios from "axios";
import _ from "lodash";
import moment from "moment";

const state = {
  currentDate: new Date(),
  releaseOverview :null,
  releaseOverviewManager :null,
  timeRecordingOverview : null,
  employeeTimeoverview : null,
  vacationReportOverview:null,
  dmEmployeeOverview:null,
  dmExternalProjectOverview:null,
  dmInternalProjectOverview:null,
  directManagerDashboardOverview:null,
  isManager:null,
  

  //=========Activity Report ========//
  projects: [],
  employees: [],
  filter: {
    date: moment()
      .startOf("month")
      .format("MM-YYYY"),
    ProjectId: 0,
    EmployeeId: 0
  },
  //=========Personal Over Report ========//
  internalEmployees: [],
  personalOverViewfilter: {
    year: moment()
      .format("YYYY"),
    EmployeeId: 0
  },
  //=========Finance Report ========//
  financeReportfilter: {
    year: moment()
      .format("YYYY"),
    CostCenterId: 0,
    OEId:0
  },
  //=========Locations Report ========//
  costCenters: [],
  employeesInCostecenters: [],
  oes: [],
  locationOverviewFilter: {
    EmployeeId: 0,
    CostCenterId: 0,
    year: moment()
      .format("YYYY")
  },
  //=========Team Report ========//
  teams: [],
  employeesInTeams: [],
  teamOverviewFilter: {
    EmployeeId: 0,
    TeamId: 0,
    year: moment()
      .format("YYYY")
  },
  //=========Un-Release Month ========//
  releasedemployeesData:[],
  unreleasefilter: {
    date: moment()
      .startOf("month")
      .format("MM-YYYY"),
    EmployeeId: 0
  },
};

const mutations = {
  //=========Activity Report ========//
  /*set date in */
  setActivityDateIn: (state, value) => {
    let filter = _.cloneDeep(state.filter);
    filter.date = value;
    state.filter = filter;
  },

  setUnReleasedDateIn: (state, value) => {
    let unreleasefilter = _.cloneDeep(state.unreleasefilter);
    unreleasefilter.date = value;
    state.unreleasefilter = unreleasefilter;
  },
  /**
   * Update filter projefct id
   */
  setFilterProjectId: (state, value) => {
    let filter = _.cloneDeep(state.filter);
    filter.ProjectId = value.ItemId;
    state.filter = filter;
  },
  setFilterEmployeeId: (state, value) => {
    let filter = _.cloneDeep(state.filter);
    filter.EmployeeId = value.ItemId;
    state.filter = filter;
  },
  setFilterReleaseEmployeeId: (state, value) => {
    let unreleasefilter = _.cloneDeep(state.unreleasefilter);
    unreleasefilter.EmployeeId = value.EmployeeId;
    state.unreleasefilter = unreleasefilter;
  },
  setQTimeActivityData: (state, value) => {
    state.projects = Object.freeze(value.item1);
    state.employees = Object.freeze(value.item2);
  },
  //=========Personal Over Report ========//
  setPersonalOverviewInYear: (state, value) => {
    let personalOverViewfilter = _.cloneDeep(state.personalOverViewfilter);
    personalOverViewfilter.year = value;
    state.personalOverViewfilter = personalOverViewfilter;
  },
  /**
   * Update filter projefct id
   */
  setpPersonalOverViewfilterEmployeeId: (state, value) => {
    let personalOverViewfilter = _.cloneDeep(state.personalOverViewfilter);
    personalOverViewfilter.EmployeeId = value.ItemId;
    state.personalOverViewfilter = personalOverViewfilter;
  },

  setPersonalOverViewData: (state, value) => {
    state.internalEmployees = Object.freeze(value);
  },
  //=========Finance Report ========//
  setfinanceReportYear: (state, value) => {
    let financeReportfilter = _.cloneDeep(state.financeReportfilter);
    financeReportfilter.year = value;
    state.financeReportfilter = financeReportfilter;
  },
  setfinanceReportCostCentreId: (state, value) => {
    let financeReportfilter = _.cloneDeep(state.financeReportfilter);
    financeReportfilter.CostCenterId = value;
    state.financeReportfilter = financeReportfilter;
  },
  //============ Location Overview  ==========//
  setLocationsData: (state, value) => {
    state.costCenters = Object.freeze(value.item1);
    state.employeesInCostecenters = Object.freeze(value.item2);
  },
  setlocationOverviewFilterCostCentreId: (state, value) => {
    let locationOverviewFilter = _.cloneDeep(state.locationOverviewFilter);
    locationOverviewFilter.CostCenterId = value.ItemId;
    state.locationOverviewFilter = locationOverviewFilter;
  },
  setlocationOverviewFilterEmployeeId: (state, value) => {
    let locationOverviewFilter = _.cloneDeep(state.locationOverviewFilter);
    locationOverviewFilter.EmployeeId = value.ItemId;
    state.locationOverviewFilter = locationOverviewFilter;
  },
  setlocationOverviewFilterYear: (state, value) => {
    let locationOverviewFilter = _.cloneDeep(state.locationOverviewFilter);
    locationOverviewFilter.year = value;
    state.locationOverviewFilter = locationOverviewFilter;
  },
  //============ Team Overview  ==========//
  setTeamsData: (state, value) => {
    state.teams = Object.freeze(value.item1);
    state.employeesInTeam = Object.freeze(value.item2);
  },
  setteamOverviewFilterTeamId: (state, value) => {
    let teamOverviewFilter = _.cloneDeep(state.teamOverviewFilter);
    teamOverviewFilter.TeamId = value.ItemId;
    state.teamOverviewFilter = teamOverviewFilter;
  },
  setteamOverviewFilterEmployeeId: (state, value) => {
    let teamOverviewFilter = _.cloneDeep(state.teamOverviewFilter);
    teamOverviewFilter.EmployeeId = value.ItemId;
    state.teamOverviewFilter = teamOverviewFilter;
  },
  setteamOverviewFilterYear: (state, value) => {
    let teamOverviewFilter = _.cloneDeep(state.teamOverviewFilter);
    teamOverviewFilter.year = value;
    state.teamOverviewFilter = teamOverviewFilter;
  },
  //============ Finance Report OE  ==========//
  setOEData: (state, value) => {
    state.oes = Object.freeze(value);
  },
  setfinanceReportOEId: (state, value) => {
    let financeReportfilter = _.cloneDeep(state.financeReportfilter);
    financeReportfilter.OEId = value;
    state.financeReportfilter = financeReportfilter;
  },
  //============ Get Released Data Of Employees  ==========//
  setReleaseEmpMonthData: (state, value) => {
    state.releasedemployeesData = Object.freeze(value);
  },
  setReleaseOverview: (state,value) => state.releaseOverview = value,
  SetTimeRecordingOverview: (state,value) => state.timeRecordingOverview = value,
  SetEmployeeTimeoverview:(state,value) => state.employeeTimeoverview = value,
  SetVacationReportOverview:(state,value) => state.vacationReportOverview = value,
  setReleaseOverviewManager: (state,value) => state.releaseOverviewManager = value,
  SetDmEmployeeOverview: (state,value) => state.dmEmployeeOverview = value,
  SetDmExternalProjectOverview: (state,value) => state.dmExternalProjectOverview = value,
  SetDmInternalProjectOverview: (state,value) => state.dmInternalProjectOverview = value,
  SetDirectManagerDashboardOverview: (state,value) => state.directManagerDashboardOverview = value,
  setIsManager: (state,value) => state.isManager = value,
};
const actions = {
  //=========Activity Report ========//
  /**
   *Fetch Activity report
   */
  fetchQTimeActivity: function ({ commit }, date) {
    commit("setGlobalLoader", true);
    //let date = {date: "2019-01-01T00:00:00"};
    return new Promise((resolve, reject) => {
      axios
        .post(url.qtime_reports_activity, date)
        .then(response => {
          if (response.data.status) {
            commit("setQTimeActivityData", response.data.responseObject);
            resolve(response);
          } else {
            reject(response);
          }
          commit("setGlobalLoader", false);
        })
        .catch(reason => {
          reject(reason);
          commit("setGlobalLoader", false);
        });
    });
  },
  /*Export Activity results */
  exportActivityReport: function ({ commit }, filter) {
    commit("setGlobalLoader", true);
    return new Promise((resolve, reject) => {
      axios
        .post(url.qtime_export_activity, filter, {
          responseType: "blob"
        })
        .then(response => {
          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute("download", "activityreport.xlsx"); //or any other extension
          document.body.appendChild(link);
          link.click();
          commit("setGlobalLoader", false);
          resolve(response);
        })
        .catch(() => {
          reject();
        });
    });
  },
  //=========Personal Over Report ========//
  fetchInternalEmployees: function ({ commit }) {
    commit("setGlobalLoader", true);
    //let date = {date: "2019-01-01T00:00:00"};
    return new Promise((resolve, reject) => {
      axios
        .get(url.qtime_personal_overview)
        .then(response => {
          if (response.data.status) {
            commit("setPersonalOverViewData", response.data.responseObject);
            resolve(response);
          } else {
            reject(response);
          }
          commit("setGlobalLoader", false);
        })
        .catch(reason => {
          reject(reason);
          commit("setGlobalLoader", false);
        });
    });
  },
  exportPersonalOverview: function ({ commit }, filter) {
    commit("setGlobalLoader", true);
    return new Promise((resolve, reject) => {
      axios
        .post(url.qtime_export_personal_overview, filter, {
          responseType: "blob"
        })
        .then(response => {
          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute("download", "personaloverviewreport.xlsx"); //or any other extension
          document.body.appendChild(link);
          link.click();
          commit("setGlobalLoader", false);
          resolve(response);
        })
        .catch(() => {
          reject();
        });
    });
  },
  //=========Finance Report ========//
  exportFinanceReport: function ({ commit }, filter) {
    commit("setGlobalLoader", true);
    return new Promise((resolve, reject) => {
      axios
        .post(url.qtime_export_finance_report, filter, {
          responseType: "blob"
        })
        .then(response => {
          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute("download", "financereport.xlsx"); //or any other extension
          document.body.appendChild(link);
          link.click();
          commit("setGlobalLoader", false);
          resolve(response);
        })
        .catch(() => {
          reject();
        });
    });
  },
  //============ Location Overview - This also used for finance  ==========//
  fetchLocationsWithEmployees: function ({ commit }, date) {
    commit("setGlobalLoader", true);
    //let date = {date: "2019-01-01T00:00:00"};
    return new Promise((resolve, reject) => {
      axios
        .get(url.qtime_location_overview, date)
        .then(response => {
          if (response.data.status) {
            commit("setLocationsData", response.data.responseObject);
            resolve(response);
          } else {
            reject(response);
          }
          commit("setGlobalLoader", false);
        })
        .catch(reason => {
          reject(reason);
          commit("setGlobalLoader", false);
        });
    });
  },
  /*Export Activity results */
  exportLocationOverview: function ({ commit }, filter) {
    commit("setGlobalLoader", true);
    return new Promise((resolve, reject) => {
      axios
        .post(url.qtime_export_location_overview, filter, {
          responseType: "blob"
        })
        .then(response => {
          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute("download", "locationoverviewreport.xlsx"); //or any other extension
          document.body.appendChild(link);
          link.click();
          commit("setGlobalLoader", false);
          resolve(response);
        })
        .catch(() => {
          reject();
        });
    });
  },
  //============ Team Overview  ==========//
  fetchTeam: function ({ commit }, date) {
    commit("setGlobalLoader", true);
    //let date = {date: "2019-01-01T00:00:00"};
    return new Promise((resolve, reject) => {
      axios
        .get(url.qtime_team_overview, date)
        .then(response => {
          if (response.data.status) {
            commit("setTeamsData", response.data.responseObject);
            resolve(response);
          } else {
            reject(response);
          }
          commit("setGlobalLoader", false);
        })
        .catch(reason => {
          reject(reason);
          commit("setGlobalLoader", false);
        });
    });
  },

  exportTeamOverview: function ({ commit }, filter) {
    commit("setGlobalLoader", true);
    return new Promise((resolve, reject) => {
      axios
        .post(url.qtime_export_team_overview, filter, {
          responseType: "blob"
        })
        .then(response => {
          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute("download", "teamoverviewreport.xlsx"); //or any other extension
          document.body.appendChild(link);
          link.click();
          commit("setGlobalLoader", false);
          resolve(response);
        })
        .catch(() => {
          reject();
        });
    });
  },
  //============ Finance Report Fetch OE ==========//
  fetchOE: function ({ commit }, date) {
    commit("setGlobalLoader", true);
    //let date = {date: "2019-01-01T00:00:00"};
    return new Promise((resolve, reject) => {
      axios
        .get(url.qtime_oe_location, date)
        .then(response => {
          if (response.data.status) {
            commit("setOEData", response.data.responseObject);
            resolve(response);
          } else {
            reject(response);
          }
          commit("setGlobalLoader", false);
        })
        .catch(reason => {
          reject(reason);
          commit("setGlobalLoader", false);
        });
    });
  },
  fetchReleaseEmpMonthData: function ({ commit }, date) {
    commit("setGlobalLoader", true);
    //let date = {date: "2019-01-01T00:00:00"};
    return new Promise((resolve, reject) => {
      axios
        .post(url.qtime_release_emp_month_data, date)
        .then(response => {
          if (response.data.status) {
            commit("setReleaseEmpMonthData", response.data.responseObject);
            resolve(response);
          } else {
            reject(response);
          }
          commit("setGlobalLoader", false);
        })
        .catch(reason => {
          reject(reason);
          commit("setGlobalLoader", false);
        });
    });
  },
  UnReleaseEmpMonth: function ({ commit }, filter) {
    commit("setGlobalLoader", true);
    return new Promise((resolve, reject) => {
        axios.post(url.qtime_unrelease_emp_month_data, filter)
            .then(
                response => {
                    if (response.data.status) {
                        //commit("setQTimeEntries", []);
                        resolve(true);
                    } else {
                        reject(false);
                    }
                    commit("setGlobalLoader", false);
                    commit("setUnReleaseSuccessModel", true);
                }
            )
            .catch(
                reason => {
                    reject(reason);
                    commit("setGlobalLoader", false);
                    commit("setUnReleaseSuccessModel", false);
                }
            )
    })
},
ManagerCheck: function ({commit}) {
  //commit("setGlobalLoader", true);
  commit("setValidateData", null);

  return new Promise((resolve, reject) => {
      axios.post(url.qtime_release_overview_ismanager_check)
          .then(
              response => {
                  if (response.data.status) {
                      commit("setIsManager", response.data.responseObject);
                      resolve(true);
                  } else {
                      reject(false);
                  }
                  //commit("setGlobalLoader", false);
              }
          )
          .catch(
              reason => {
                  reject(reason);
                  commit("setGlobalLoader", false);
              }
          )
  })
},
exportEmployees: function ({ commit }) {
  commit("setGlobalLoader", true);
  return new Promise((resolve, reject) => {
    axios
      .post(url.qtime_export_employees_data,null, {
        responseType: "blob"
      })
      .then(response => {
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", "employeesreport.xlsx"); //or any other extension
        document.body.appendChild(link);
        link.click();
        commit("setGlobalLoader", false);
        resolve(response);
      })
      .catch(() => {
        reject();
      });
  });
},
ReleaseOverview: function ({commit}) {
  commit("setGlobalLoader", true);
  commit("setValidateData", null);

  return new Promise((resolve, reject) => {
      axios.post(url.qtime_release_overview)
          .then(
              response => {
                  if (response.data.status) {
                      commit("setReleaseOverview", response.data.responseObject);
                      resolve(true);
                  } else {
                      reject(false);
                  }
                  commit("setGlobalLoader", false);
              }
          )
          .catch(
              reason => {
                  reject(reason);
                  commit("setGlobalLoader", false);
              }
          )
  })
},
TimeRecordingOverview: function ({commit}) {
  commit("setGlobalLoader", true);
  commit("setValidateData", null);

  return new Promise((resolve, reject) => {
      axios.post(url.qtime_time_recording_overview)
          .then(
              response => {
                  if (response.data.status) {
                      commit("SetTimeRecordingOverview", response.data.responseObject);
                      resolve(true);
                  } else {
                      reject(false);
                  }
                  commit("setGlobalLoader", false);
              }
          )
          .catch(
              reason => {
                  reject(reason);
                  commit("setGlobalLoader", false);
              }
          )
  })
},

EmployeeTimeoverview : function({commit}) {
  commit("setGlobalLoader", true);
  commit("setValidateData", null);

  return new Promise((resolve, reject) => {
      axios.post(url.qtime_time_employee_time_overview)
          .then(
              response => {
                  if (response.data.status) {
                      commit("SetEmployeeTimeoverview", response.data.responseObject);
                      resolve(true);
                  } else {
                      reject(false);
                  }
                  commit("setGlobalLoader", false);
              }
          )
          .catch(
              reason => {
                  reject(reason);
                  commit("setGlobalLoader", false);
              }
          )
  })
},

VacationReportOverview : function({commit}) {
  commit("setGlobalLoader", true);
  commit("setValidateData", null);

  return new Promise((resolve, reject) => {
      axios.post(url.qtime_time_vacation_report_overview)
          .then(
              response => {
                  if (response.data.status) {
                      commit("SetVacationReportOverview", response.data.responseObject);
                      resolve(true);
                  } else {
                      reject(false);
                  }
                  commit("setGlobalLoader", false);
              }
          )
          .catch(
              reason => {
                  reject(reason);
                  commit("setGlobalLoader", false);
              }
          )
  })
},
DMEmployeeOverview: function({commit}) {
  commit("setGlobalLoader", true);
  commit("setValidateData", null);

  return new Promise((resolve, reject) => {
      axios.post(url.qtime_delivery_manager_employee_overview)
          .then(
              response => {
                  if (response.data.status) {
                      commit("SetDmEmployeeOverview", response.data.responseObject);
                      resolve(true);
                  } else {
                      reject(false);
                  }
                  commit("setGlobalLoader", false);
              }
          )
          .catch(
              reason => {
                  reject(reason);
                  commit("setGlobalLoader", false);
              }
          )
  })
},
DMExternalProjectOverview: function({commit}) {
  commit("setGlobalLoader", true);
  commit("setValidateData", null);

  return new Promise((resolve, reject) => {
      axios.post(url.qtime_delivery_manager_external_project_overview)
          .then(
              response => {
                  if (response.data.status) {
                      commit("SetDmExternalProjectOverview", response.data.responseObject);
                      resolve(true);
                  } else {
                      reject(false);
                  }
                  commit("setGlobalLoader", false);
              }
          )
          .catch(
              reason => {
                  reject(reason);
                  commit("setGlobalLoader", false);
              }
          )
  })
},
DMInternalProjectOverview: function({commit}) {
  commit("setGlobalLoader", true);
  commit("setValidateData", null);

  return new Promise((resolve, reject) => {
      axios.post(url.qtime_delivery_manager_internal_project_overview)
          .then(
              response => {
                  if (response.data.status) {
                      commit("SetDmInternalProjectOverview", response.data.responseObject);
                      resolve(true);
                  } else {
                      reject(false);
                  }
                  commit("setGlobalLoader", false);
              }
          )
          .catch(
              reason => {
                  reject(reason);
                  commit("setGlobalLoader", false);
              }
          )
  })
},
DirectManagerDashboardOverview: function({commit}) {
  commit("setGlobalLoader", true);
  commit("setValidateData", null);

  return new Promise((resolve, reject) => {
      axios.post(url.qtime_direct_manager_internal_project_overview)
          .then(
              response => {
                  if (response.data.status) {
                      commit("SetDirectManagerDashboardOverview", response.data.responseObject);
                      resolve(true);
                  } else {
                      reject(false);
                  }
                  commit("setGlobalLoader", false);
              }
          )
          .catch(
              reason => {
                  reject(reason);
                  commit("setGlobalLoader", false);
              }
          )
  })
},
ReleaseOverviewManager: function ({commit}) {
  commit("setGlobalLoader", true);
  commit("setValidateData", null);

  return new Promise((resolve, reject) => {
      axios.post(url.qtime_release_overview_manager)
          .then(
              response => {
                  if (response.data.status) {
                      commit("setReleaseOverviewManager", response.data.responseObject);
                      resolve(true);
                  } else {
                      reject(false);
                  }
                  commit("setGlobalLoader", false);
              }
          )
          .catch(
              reason => {
                  reject(reason);
                  commit("setGlobalLoader", false);
              }
          )
  })
}
};
export default {
  state,
  mutations,
  actions
};
